import { Button, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { WarningFilled } from "@ant-design/icons";
import { SelectTaskTemplateModalProps } from "types/PPFUser/taskTemplates";
import Avatar from "components/@extended/Avatar";
import { PopupTransition } from "components/@extended/Transitions";

const SelectTaskTemplateModal = ({ open, onClose, isApplying, handleConfirm }: SelectTaskTemplateModalProps) => {
    return (
        <Dialog
            open={open}
            onClose={() => onClose()}
            slots={{ transition: PopupTransition }}
            keepMounted
            maxWidth="xs"
            aria-labelledby="template-overwrite-title"
            aria-describedby="template-overwrite-description"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '12px'
                }
            }}
        >
            <DialogContent sx={{ mt: 2, my: 1 }}>
                <Stack sx={{ gap: 3.5, alignItems: 'center' }}>
                    <Avatar color="warning" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
                        <WarningFilled />
                    </Avatar>
                    <Stack sx={{ gap: 2 }}>
                        <Typography variant="h4" align="center">
                            Are you sure?
                        </Typography>
                        <Typography align="center">If Continue with selected template will overwrite all saved changes</Typography>
                    </Stack>

                    <Stack direction="row" sx={{ gap: 2, width: 1 }}>
                        <Button fullWidth onClick={() => onClose()} color="secondary" variant="outlined">
                            Cancel
                        </Button>
                        <Button fullWidth color="primary" variant="contained" onClick={handleConfirm} autoFocus disabled={isApplying}>
                            Continue
                        </Button>
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default SelectTaskTemplateModal
